import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Sirve para todos los niveles?',
  answer: 'Sí. Está organizado por nivel de idioma MCER (A1→C2). Funciona en cualquier contexto donde se enseñe italiano.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'En menos de 5 minutos después del pago recibís el link de descarga por mail.'
}, {
  question: '¿Qué lo diferencia del material online?',
  answer: 'Está pensado para el alumno argentino, tiene solucionario completo con justificaciones gramaticales y cubre todos los niveles con coherencia de progresión. No son hojas sueltas — es un sistema.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días, devolución del 100%. Escribís a soporteprofepack@gmail.com y listo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-128">
      <div className="max-w-3xl mx-auto" data-id="element-129">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-130">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3 mb-10" data-id="element-131">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#00C853] bg-[#000d08]' : 'border-[#00C853]/20 bg-black'}`} data-id="element-132">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-133">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-134">
                  {faq.question}
                </span>
                <span className={`text-[#00C853] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-135">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-136">
                  <div className="h-px bg-[#00C853]/20 mb-4" data-id="element-137" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-138">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}